import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { ClientRepository } from "../client/client.repository";
import { LocationRepository } from "../location/location.repository";
import { TierRepository } from "../tier/tier.repository";
import { QuoteBatchMailEditorComponent } from "./quote-batch-mail-editor/quote-batch-mail-editor.component";
import { QuoteFormComponent } from "./quote-form/quote-form.component";
import { QuoteChipsComponent } from "./quote-form/quote-chips/quote-chips.component";
import { QuoteFormActionsComponent } from "./quote-form/quote-form-actions/quote-form-actions.component";
import { QuotePackageComponent } from "./quote-form/quote-package/quote-package.component";
import { QuoteMailEditorComponent } from "./quote-mail-editor/quote-mail-editor.component";
import { QuoteManualEditorComponent } from "./quote-manual-editor/quote-manual-editor.component";
import { QuoteOptionsComponent } from "./quote-options/quote-options.component";
import { QuotePreviewComponent } from "./quote-preview/quote-preview.component";
import { EquipmentQuantityComponent } from "./quote-equipment/equipment-quantity.component";
import { QuoteFreightRateComponent } from "./quote-freight-rate/quote-freight-rate.component";
import { FreightRateGroupService } from "./quote-freight-rate/freight-rate-group/freight-rate-group.service";
import { QuoteRoutingModule } from "./quote-routing.module";
import { QuoteSurchargeComponent } from "./quote-surcharge/quote-surcharge.component";
import { QuoteTermsComponent } from "./quote-terms/quote-terms.component";
import { QuoteRepository } from "./quote.repository";
import { QuoteContractListComponent } from "./quote-contract-list/quote-contract-list.component";
import { NgxPermissionsModule } from "ngx-permissions";
import { QuoteLocationSurchargeRepository } from "./quote-surcharge/quote-location-surcharge.repository";
import { SharedModule } from "../shared/shared.module";
import { NotifyModule } from "../notify/notify.module";
import { UiModule } from "../ui/ui.module";
import { QuoteListComponent } from "./quote-list/quote-list.component";
import { StripHtmlTagsPipe } from "../shared/html/strip-html-tags.pipe";
import { ConvertSpacesPipe } from "../shared/html/convert-spaces.pipe";
import { QuoteAttachmentRepository } from "./quote-attachment.repository";
import { RouteRepository } from "../route/route.repository";

import { FreightRateBatchSelectComponent } from "./quote-freight-rate/freight-rate-batch-select/freight-rate-batch-select.component";
import { FreightRateBatchMarginComponent } from "./quote-freight-rate/freight-rate-batch-margin/freight-rate-batch-margin.component";

import { QuoteListBatchActionsComponent } from "./quote-list/quote-list-batch-actions/quote-list-batch-actions.component";
import { ClientContactPersonRepository } from "../client/client-contact-person-list/client-contact-person.repository";
import { RateRepository } from "../rate/rate.repository";
import { LocationSurchargeRepository } from "../location/location-surcharge/location-surcharge.repository";
import { CarrierRepository } from "../carrier/carrier.repository";
import { QuoteChipsSingleComponent } from "./quote-form/quote-chips-single/quote-chips-single.component";
import { SurchargeTypeRepository } from "../surcharge-type/surcharge-type.repository";
import { QuoteLtlSurchargeComponent } from "./quote-ltl-surcharge/quote-ltl-surcharge.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { DatePickerModule as PrimeNgDatePickerModule } from "primeng/datepicker";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { DialogModule } from "primeng/dialog";
import { SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { PanelModule } from "primeng/panel";
import { BlockUIModule } from "primeng/blockui";
import { TabsModule } from "primeng/tabs";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { TooltipModule } from "primeng/tooltip";
import { AccordionModule } from "primeng/accordion";
import { PopoverModule } from "primeng/popover";
import { TextareaModule } from "primeng/textarea";
import { MultiSelectModule } from "primeng/multiselect";
import { ProgressBarModule } from "primeng/progressbar";
import { ContextMenuModule } from "primeng/contextmenu";
import { DigitOnlyDirective } from "@uiowa/digit-only";
import { EquipmentQuantityService } from "./quote-equipment/equipment-quantity.service";
import { QuoteVariantSelectComponent } from "./quote-variant-select/quote-variant-select.component";
import { PackageRepository } from "./quote-form/quote-package/package.repository";
import { QuoteCreateComponent } from "./quote-create/quote-create.component";
import { QuoteInsuranceComponent } from "./quote-form/quote-insurance/quote-insurance.component";
import { ClientPotentialFormModule } from "app/client/client-potential-form/client-potential-form.module";
import { QuoteDeclineFormModule } from "./quote-decline-form/quote-decline-form.module";
import { SelectButtonModule } from "primeng/selectbutton";
import { QuoteChipsGroupComponent } from "./quote-form/quote-chips-group/quote-chips-group.component";
import { LocationGroupRepository } from "app/location-group/location-group.repository";
import { DatePickerModule } from "app/ui/date-picker/date-picker.module";
import { OrganizationRepository } from "app/organization/organization.repository";
import { QuoteAiModule } from "./quote-form/quote-ai/quote-ai.module";
import { QuoteMaerskLocationsComponent } from "./quote-maersk-locations/quote-maersk-locations.component";

@NgModule({
  imports: [
    SharedModule,
    NgxPermissionsModule,
    AutoCompleteModule,
    PrimeNgDatePickerModule,
    QuoteDeclineFormModule,
    AutoCompleteModule,
    CheckboxModule,
    PopoverModule,
    RadioButtonModule,
    InputTextModule,
    CommonModule,
    DatePickerModule,
    DialogModule,
    SelectButtonModule,
    SelectModule,
    InputTextModule,
    FormsModule,
    NotifyModule,
    PanelModule,
    QuoteRoutingModule,
    ClientPotentialFormModule,
    BlockUIModule,
    ReactiveFormsModule,
    TabsModule,
    ToggleButtonModule,
    ToggleSwitchModule,
    TooltipModule,
    UiModule,
    AccordionModule,
    PopoverModule,
    PdfViewerModule,
    TextareaModule,
    MultiSelectModule,
    ProgressBarModule,
    ContextMenuModule,
    DigitOnlyDirective,
    QuoteAiModule,
    QuoteChipsComponent,
    QuoteChipsSingleComponent,
    QuoteChipsGroupComponent,
    QuoteFormComponent,
    QuoteListComponent,
    QuoteMailEditorComponent,
    QuotePreviewComponent,
    EquipmentQuantityComponent,
    QuoteFreightRateComponent,
    QuoteVariantSelectComponent,
    QuoteSurchargeComponent,
    QuoteTermsComponent,
    QuoteOptionsComponent,
    QuoteManualEditorComponent,
    QuoteManualEditorComponent,
    QuoteBatchMailEditorComponent,
    QuoteCreateComponent,
    StripHtmlTagsPipe,
    ConvertSpacesPipe,
    QuoteContractListComponent,
    FreightRateBatchSelectComponent,
    FreightRateBatchMarginComponent,
    QuoteListBatchActionsComponent,
    QuoteLtlSurchargeComponent,
    QuoteFormActionsComponent,
    QuotePackageComponent,
    QuoteInsuranceComponent,
    QuoteMaerskLocationsComponent,
  ],
  providers: [
    ClientRepository,
    CarrierRepository,
    PackageRepository,
    ClientContactPersonRepository,
    LocationRepository,
    LocationGroupRepository,
    QuoteRepository,
    RouteRepository,
    QuoteAttachmentRepository,
    SurchargeTypeRepository,
    TierRepository,
    RateRepository,
    FreightRateGroupService,
    EquipmentQuantityService,
    QuoteLocationSurchargeRepository,
    LocationSurchargeRepository,
    OrganizationRepository,
  ],
  exports: [QuoteListComponent],
})
export class QuoteModule {}
